<template lang="pug" id="avatar">

.message-avatar(:class="positioningClass")
  img(v-if="avatarPhoto"
     :src="avatarPhoto" 
     :alt="avatarAltText")
  .no-image(v-else-if="senderInitials") {{ senderInitials }}
  img(v-else :src="photo" 
     :alt="avatarAltText")
</template>

<style lang="scss" scoped>
.message-avatar.webchat-item-left {
  order: 0;
  justify-content: start;
}
.message-avatar.webchat-item-right {
  order: 3;
  justify-content: flex-end;
  margin-bottom: 9px;
}
.message-avatar.hidden {
  display: none;
}
</style>

<script>
import { getPositioningClass } from '../lib/avatar';

import defaultPhoto from '../assets/messages/photo.jpg';

export default {
  name: 'avatar',
  props: {
    avatarPhoto: {
      type: String,
    },
    inWebchat: {
      type: Boolean,
      required: true,
    },
    senderType: {
      type: String,
      required: true,
    },
    senderInitials: {
      type: [String, Number], // We should not be passing anything other than string here.
    },
    avatarAltText: {
      type: String,
    },
  },
  computed: {
    photo() {
      return defaultPhoto;
    },
    positioningClass() {
      const { inWebchat, senderType } = this;
      return getPositioningClass({ inWebchat, senderType });
    },
  },
};
</script>
